/* eslint-disable */

$('#researchTabs li a').click(function() {
  if($(this).attr('data-target') == '#primary') {
    $('.alphabet-filter').fadeIn();
    getDistance();
    first_char = JSON.parse(first_char_pi);

    $('.tax-research_status .num').addClass('disabled');
    $('.research-documents .num').addClass('disabled');

    for (var i = 0; i < first_char.length; i++) {
      $('[data-filter="' + first_char[i] + '"]').removeClass('disabled');
      $('[data-filter="' + first_char[i] + '"]').attr('href', '#' + first_char[i]);
    }

  } else if($(this).attr('data-target') == '#sponsor')  {
    $('.alphabet-filter').fadeIn();
    getDistance();
    $('.tax-research_status .num').addClass('disabled');
    $('.research-documents .num').addClass('disabled');
  } else {
    $('.alphabet-filter').hide().removeClass('active');
  }
});

$('.pi__container').click(function(event) {

  var id = $(this).attr('id');

  var $wrapper = $('#' + id).children('.pi__info');

  var $container = $('#' + id).children('.pi__ajax_content');

  if(event.target.nodeName.toLowerCase() != 'a' && $(this).hasClass('active')) {
    $(this).removeClass('active');
    $wrapper.slideUp();
    $container.empty();
  } else if(event.target.nodeName.toLowerCase() == 'a') {
    // do nothing
  } else {
    $(this).addClass('active');
    jQuery.ajax({
      type       : "GET",
      data       : {
        dataType   : "jsonp",
        action:'ajax_pi_research',
        pi_id: id,
        taxonomy: taxonomy,
        current_site: current_site,
      },
      url: '../../wp-admin/admin-ajax.php',
      success    : function(data){
        if(data.length) {
          var content = data;
          $wrapper.hide().slideDown();
          $(content).hide().appendTo($container).slideDown();
        }
      },
    });
  }
});

$('body').on('click', '.sponsor__container', function() {

  var id = $(this).attr('id');

  var $wrapper = $('#' + id).children('.sponsor__info');

  if($(this).hasClass('active')) {
    $(this).removeClass('active');
    $wrapper.slideUp();
  } else {
    $wrapper.slideDown();
    $(this).addClass('active');
  }
});

// Sticky Nav For Alphabet Filter

var distance;

function getDistance() {
  let distanceXY = { top: 0, bottom:0 };
  if($('.alphabet-filter').length && $('.alphabet-filter').is(":visible")) {
    distanceXY = $(".alphabet-filter").position();
  } else if($('.alphabet-hide').length != 0) {
    distanceXY = $('.alphabet-hide').position(); //gets offset
  }
  else {  }
  distance = distanceXY.top;
  //console.log('getDistance value: ' + distance);
}

function setTabs() {

  if ($('.mobile-nav').is(":visible") ) {

    var tab = $('.mobile-nav select').find("option:selected").val();

  } else {

    var tab = $('#researchTabs .nav-item a.active').data('target');
  }

  //console.log(tab);

  //console.log('set tabs');


  if( tab == '#primary' || tab == '#people' || tab == '#sponsor') {
    $('.research__filter_top .alphabet-filter').fadeIn().removeClass('active');
  } else {
    $('.research__filter_top .alphabet-filter').fadeOut();
  }


  $('#researchTabs a[data-target="' + tab + '"]').click();
}

$(window).resize(function() {
  if($('.alphabet-filter').length != 0) {
    getDistance();
  }
});

// Collapse nav tabs

$(function() {
  setTabs();
  getDistance();


  // Create the dropdown base
  $('<div class="mobile-nav"></div>').appendTo('#researchTabs');
  $('<select></select>').appendTo('#researchTabs .mobile-nav');

  // Populate dropdown with menu items
  $('#researchTabs a').each(function() {
    var el = $(this);
    $('<option />', {
      'value'   : el.attr('data-target'),
      'text'    : el.text()
    }).appendTo('#researchTabs select');
    // tabs apparently need to each be enabled separately
    $(el).click(function (e) {
      e.preventDefault()
      $(this).tab('show')
    })
  });

  // To make dropdown actually work
  $('#researchTabs select').change(function() {
    setTabs();
  });

  $(window).scroll(
    function() {
      if($('.alphabet-filter').length && $('.alphabet-filter').is(":visible")) {

        //console.log('scrolling on the alphabet element visible');
        if($(window).scrollTop() >= (distance)) {
          //console.log('window top:' + $(window).scrollTop());
          //console.log(' distance scrolling top:' + distance);
          $('.alphabet-filter').addClass('active');
        }

        else {
          $('.alphabet-filter').removeClass('active');
        }
      }
  });

});

// Ajax research impact

$('.moreresearchimpact').click(function() {
  var $container = $('.researchimpact__ajax');
  var categories = new Array();
  var sites = new Array();

  jQuery.ajax({
    type       : "GET",
    data       : {
      posts: usedIDs,
      page: pageNumber,
      dataType   : "jsonp",
      action:'more_researchimpact',
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      pageNumber++;
      if(data.length) {
        data = JSON.parse(data);
        var totalPages = data[0];
        var content = data[1];

        $(content).hide().appendTo($container).fadeIn(300);

        if (pageNumber >= totalPages) {
         $('.moreresearchimpact').empty().append('<div>Sorry, no more research impact</div>');
        }
      }
    },
  });
});

// Ajax Research Sponsors

$('.tax-research_status #researchTabs li a[data-target="#sponsor"]').click(function() {
  var $sponsor_container = $('.ajax__sponsor_content');

  jQuery.ajax({
    type       : "GET",
    data       : {
      taxonomy: taxonomy,
      current_site: current_site,
      dataType: "jsonp",
      action:'ajax_sponsor_research',
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      if(data.length) {
        data = JSON.parse(data);
        var content = data[0];
        var first_char = data[1];

        $sponsor_container.empty();
        $(content).hide().appendTo($sponsor_container).fadeIn(300);

        for (var i = 0; i < first_char.length; i++) {
          $('[data-filter="' + first_char[i] + '"]').removeClass('disabled');
          $('[data-filter="' + first_char[i] + '"]').attr('href', '#sponsor-' + first_char[i]);
        }

      }
    },
  });

})

// Ajax Research Focus Areas

$('.tax-research_status #researchTabs li a[data-target="#focusarea"]').click(function() {
  var $focusarea_container = $('.ajax__focus_area_content');

  jQuery.ajax({
    type       : "GET",
    data       : {
      taxonomy: taxonomy,
      current_site: current_site,
      dataType: "jsonp",
      action:'ajax_focus_area_research',
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      if(data.length) {
        var content = data;

        $focusarea_container.empty();
        $(content).appendTo($focusarea_container).fadeIn(300);

      }
    },
  });

})

// Ajax Research End Date

$('.tax-research_status #researchTabs li a[data-target="#enddate"]').click(function() {
  var $enddate_container = $('.ajax__end_date_content');

  jQuery.ajax({
    type       : "GET",
    data       : {
      taxonomy: taxonomy,
      current_site: current_site,
      dataType: "jsonp",
      action:'ajax_end_date_research',
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      if(data.length) {
        var content = data;

        $enddate_container.empty();
        $(content).appendTo($enddate_container).fadeIn(300);

      }
    },
  });

})

// Ajax Research Start Date

$('.tax-research_status #researchTabs li a[data-target="#startdate"]').click(function() {
  var $startdate_container = $('.ajax__start_date_content');

  jQuery.ajax({
    type       : "GET",
    data       : {
      taxonomy: taxonomy,
      current_site: current_site,
      dataType: "jsonp",
      action:'ajax_start_date_research',
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      if(data.length) {
        var content = data;

        $startdate_container.empty();
        $(content).appendTo($startdate_container).fadeIn(300);

      }
    },
  });

});



// WEBPACK FOOTER //
// ./scripts/routes/research.js